import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKnifeBoard = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "knife-board" }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M20.25,14.25H22.5a.75.75,0,0,0,.75-.75V1.5A.75.75,0,0,0,22.5.75H4.5a.75.75,0,0,0-.75.75v.75a1.5,1.5,0,0,1-.6,1.2L1.35,4.8A1.5,1.5,0,0,0,.75,6V9a1.5,1.5,0,0,0,.6,1.2l1.8,1.35a1.5,1.5,0,0,1,.6,1.2v.75a.75.75,0,0,0,.75.75H6.75"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 3.75,
			y1: 6.75,
			x2: 3.75,
			y2: 8.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M18.833,17.28l4.1,4.095a1.1,1.1,0,0,1,0,1.553h0a1.1,1.1,0,0,1-1.553,0l-4.092-4.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M10.327,8.775l8.506,8.505-3.387,3.388a1.1,1.1,0,0,1-1.648-.107c-3.535-4.7-5.255-8.728-4.435-11.552A.579.579,0,0,1,10.327,8.775Z"
		})
	]
});
export default SvgKnifeBoard;
